import React from 'react'
import { Box, Flex, Heading, Image, Link, Text, VStack } from '@chakra-ui/react'
import { ExternalLinkIcon } from '@chakra-ui/icons'
import { NewsItem, StockData } from '../types'
import { formatDate } from '../utils'
import { newsStyles } from '../styles'

interface NewsPanelProps {
  data: StockData
  cardBg: string
}

const NewsCard: React.FC<{ news: NewsItem, bg: string }> = ({ news, bg }) => (
  <Box
    bg={bg}
    borderRadius="md"
    boxShadow="sm"
    mb={4}
    overflow="hidden"
    transition="transform 0.2s"
    _hover={{ transform: 'translateY(-2px)' }}
  >
    <Flex direction={{ base: 'column', sm: 'row' }}>
      {news.image && (
        <Box 
          flexShrink={0}
          height={{ base: '150px', sm: '120px' }}
          width={{ base: '100%', sm: '180px' }}
        >
          <Image
            alt={news.headline}
            height="100%"
            objectFit="cover"
            src={news.image}
            width="100%"
          />
        </Box>
      )}
      
      <Box p={4}>
        <Heading as="h4" fontSize="md" mb={1}>
          <Link href={news.url} isExternal>
            {news.headline} <ExternalLinkIcon mx="2px" />
          </Link>
        </Heading>
        
        <Flex 
          align="center" 
          color="gray.500" 
          fontSize="xs" 
          mb={2}
        >
          <Text mr={2}>{news.source}</Text>
          <Text>{formatDate(news.datetime)}</Text>
        </Flex>
        
        <Text fontSize="sm" noOfLines={2}>
          {news.summary}
        </Text>
      </Box>
    </Flex>
  </Box>
)

const NewsPanel: React.FC<NewsPanelProps> = ({
  data,
  cardBg
}) => (
  <>
    <Heading as="h3" fontSize="xl" mb={4}>
      Recent News
    </Heading>
    
    <Box
      sx={newsStyles}
      pr={2}
    >
      <VStack align="stretch" spacing={4}>
        {data.news.map((newsItem, index) => (
          <NewsCard
            key={index}
            news={newsItem}
            bg={cardBg}
          />
        ))}
      </VStack>
    </Box>
  </>
)

export default NewsPanel
